module.exports = __webpack_public_path__ + "static/media/Covid-2021-Website.0e834ac1.mp4";